var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPause(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 40,
    viewBox: "0 0 28 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.12743 13.2812C2.0736 10.9547 2.12761 5.53881 3.12484 4.17555C5.66521 1.0105 9.12389 3.08371 9.62765 3.55767C11.9682 5.75971 11.2056 30.014 11.2056 32.1698C11.7664 38.3565 5.42518 37.3253 5.23727 37.1338C5.00256 36.8946 4.43442 36.674 4.10642 36.5255C3.5562 36.2762 3.47324 35.7145 3.40749 35.232C3.2991 34.4366 3.11067 33.6623 2.94416 32.8627C2.77633 32.0568 2.83421 31.2341 2.83421 30.4166C2.83421 29.2148 2.69286 28.0206 2.69286 26.8243C2.69286 24.4906 2.5515 22.1679 2.5515 19.8382C2.5515 17.6354 2.17805 15.4686 2.12743 13.2812Z",
    stroke: "#D9FC51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5521 20.8218C17.4862 19.1269 16.4203 6.93765 19.1368 3.36602C20.6658 1.85956 23.0901 3.82335 24.1486 5.18154C24.4772 5.60323 24.548 6.42692 24.6831 6.93765C24.9003 7.75862 24.9086 8.63239 25.0541 9.47279C25.3125 10.9646 25.2043 12.6152 25.5887 14.0677C25.7088 14.522 25.6084 15.0034 25.6704 15.4673C25.7758 16.2555 25.7584 17.0499 25.7584 17.844V20.1283C25.7584 22.4661 25.4189 24.8245 25.4189 27.1527C25.4189 29.1736 25.3057 31.1846 25.3057 33.1935C25.3057 34.3213 25.3525 35.47 24.7397 36.435C23.5981 38.2328 21.423 38.2938 20.2686 36.4086C20.0324 36.0229 19.6313 35.7306 19.4448 35.3391C19.1305 34.6791 18.3382 33.6764 18.3382 32.9297C18.3382 30.5799 18.1043 28.1438 17.8603 25.8063C17.69 24.175 17.616 22.4644 17.5521 20.8218Z",
    stroke: "#D9FC51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.81a0ced1ba2d979afc36c63d945cf99f.svg";
export { ForwardRef as ReactComponent };